import React from 'react';
import '../styles/Legal.css';

const LegalPrivacy = () => {
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>

      <h2>What We Collect</h2>
      <ul>
        <li>Account data: email, name/IGN, team info.</li>
        <li>Usage data: logs, device info, in-app actions.</li>
        <li>Payment data: handled by our payment processor; we don’t store full card details.</li>
      </ul>

      <h2>How We Use It</h2>
      <p>Provide and improve the service, support users, secure accounts, process payments, communicate updates.</p>

      <h2>Sharing</h2>
      <ul>
        <li>With service providers (hosting, analytics, payments) under appropriate safeguards.</li>
        <li>If required by law or to protect rights/safety.</li>
        <li>In a merger/acquisition, your data may transfer with notice.</li>
      </ul>

      <h2>Cookies/Tracking</h2>
      <p>We use cookies or similar tech for auth, preferences, analytics.</p>

      <h2>Data Retention</h2>
      <p>We keep data as needed for service, legal, and security purposes. You may request deletion of your account data (subject to legal retention needs).</p>

      <h2>Security</h2>
      <p>We use reasonable technical and organizational measures, but no system is 100% secure.</p>

      <h2>Your Rights</h2>
      <p>Depending on your region, you may request access, correction, deletion, or portability of your data, and opt out of certain processing. Contact us at cali.salcedo@theboxesports.com.</p>

      <h2>Children</h2>
      <p>Not intended for users under 16 (or your local minimum age). We don’t knowingly collect from children.</p>

      <h2>International Transfers</h2>
      <p>Data may be processed in countries with different laws; we use safeguards where required.</p>

      <h2>Startup/Partnership Note</h2>
      <p>TheBoxEsports is evolving; we’re iterating and improving. We value communication and feedback to address issues quickly.</p>

      <h2>Changes</h2>
      <p>We may update this policy; material changes will be communicated.</p>

      <h2>Contact</h2>
      <p>cali.salcedo@theboxesports.com (Founder, TheBoxEsports)</p>
    </div>
  );
};

export default LegalPrivacy;
